import { render, staticRenderFns } from "./RestaurantFacilities.vue?vue&type=template&id=506cbd33&scoped=true&"
import script from "./RestaurantFacilities.vue?vue&type=script&lang=js&"
export * from "./RestaurantFacilities.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantFacilities.vue?vue&type=style&index=0&id=506cbd33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506cbd33",
  null
  
)

export default component.exports